import React from 'react'
import ApproveUsersTable from '../../components/ApproveUsersTable/ApproveUsersTable'
import styles from './ApproveUsersPage.module.css'

const ApproveUsersPage = () => {
  return (
    <div className={styles.pageContainer}>
      <h2 className={styles.title}> Approval Level User Creation Requests </h2>
      <ApproveUsersTable />
    </div>
  );
};

export default ApproveUsersPage;